<template>
      <div id="contactTypeForm" class="form">
        <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
          <v-text-field
              v-model="contactType.name"
              label="Name"
              :required="true"
            />
            <v-text-field
              v-model="contactType.description"
              label="Description"
              :required="false"
            />
            

          <v-radio-group v-model="contactType.has_student" row>
            <template v-slot:label>
              <div>Has Student</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_teacher" row>
            <template v-slot:label>
              <div>Has Teacher</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_ledger" row>
            <template v-slot:label>
              <div>Has Ledger</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_appointment" row>
            <template v-slot:label>
              <div>Has Appointment</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_note" row>
            <template v-slot:label>
              <div>Has Notes</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_calls" row>
            <template v-slot:label>
              <div>Has Calls</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_email" row>
            <template v-slot:label>
              <div>Has Emails</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_sms" row>
            <template v-slot:label>
              <div>Has SMS</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_inquiry" row>
            <template v-slot:label>
              <div>Has Inquiry</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_group" row>
            <template v-slot:label>
              <div>Has Group</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_attachment" row>
            <template v-slot:label>
              <div>Has Attachment</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>

          <v-radio-group v-model="contactType.has_car" row>
            <template v-slot:label>
              <div>Has Car</div>
            </template>
              <v-radio value="true">
                <template v-slot:label>
                  <div>Yes</div>
                </template>
              </v-radio>
            
              <v-radio value="false">
                <template v-slot:label>
                  <div>No</div>
                </template>
              </v-radio>
            </v-radio-group>
        <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
        </v-form>
      </div>
    </template>
    
<script>
  import { getContactType } from "@/services/contactType";
  
  
  import { mapActions } from "vuex";

  

  export default {
    props: ["id"],
    data () {
      return {
        loaded: false,
        valid: false,
        contactType: {
          relations: {
            
          },
          name: '',
description: '',
has_student:  '',
has_teacher:  '',
has_ledger:  'true',
has_appointment:  'true',
has_note:  'true',
has_calls:  'true',
has_email:  'true',
has_sms:  'true',
has_inquiry:  'true',
has_group:  'true',
has_attachment:  'true',
has_car:  'true',

        }
      }
    },
    created() {
      this.setInstance();
    },
    methods: {
      ...mapActions("contactType", ["createContactType", "updateContactType"]),
      ...mapActions("messages", [
        "addMessage",
        "addErrorMessage",
        "addSuccessMessage"
      ]),
      
      async handleSubmit() {
        if (this.id) {
          let contactType = this.contactType;
          delete contactType.relations;

          this.updateContactType(contactType)
          .then( (response) => {
            console.log(response);
            this.addSuccessMessage("ContactType was updated successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error updating ContactType, please try again later");
          });
        } else {
          let contactType = this.contactType;
          delete contactType.relations;

          this.createContactType(contactType)
          .then( response => {
            console.log(response);
            this.addSuccessMessage("ContactType was created successfully");
            this.goBack();
          }).catch( () => {
            this.addErrorMessage("Error creating ContactType, please try again later");
          })
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      setInstance() {
        if (this.id) {
          this.contactType.id = this.id;
          getContactType(this.id)
            .then(response => {
              let instance = response.data;
              for (let property in instance) {
                if (Object.prototype.hasOwnProperty.call(instance, property) && Object.prototype.hasOwnProperty.call(this.contactType, property)) {
                  this.contactType[property] = instance[property];
                }
              }
              this.loaded = true;
            })
        } else {
          this.loaded = true;
        }
        this.setDependencies();
      },
      setDependencies() {
        
      }
    },
    components: {
      
    }
  }
</script>
